import { DocsTocGroup, HelpSectionConfig } from '../types';

export const HELP_CENTER_TITLE = 'Help Center';

export const HELP_CENTER_SUBTITLE =
  'Find answers and guidance across access & security, registration, and development';

export const HELP_DEFAULT_SECTION_ID = 'access-and-security';

export const HELP_SECTIONS: HelpSectionConfig[] = [
  {
    id: 'access-and-security',
    title: 'Access & Security',
    questions: [
      'What is an API Key',
      'What are the available developer environments?',
      'How can I get access to the Sandbox environment?',
      'How can I get access to the Production environment?',
      `I've removed the "Production" API Product from my APP. How to get it back?`,
      'What do I need to fill in as grant_type?',
      'Is the JWT Token generated after authentication digitally signed?',
      'Is the JWT Token generated after authentication encrypted?',
      'Is the client ID and Client Secret values encrypted?',
      'Is Digital Realty following IETF security best practices for JWT?',
    ],
    navigatePaths: {
      'What is an API Key':
        '/docs/help/access-and-security/what-is-an-api-key.md',
      'What are the available developer environments?':
        '/docs/help/access-and-security/available-environments.md',
      'How can I get access to the Sandbox environment?':
        '/docs/help/access-and-security/how-get-sandbox-access.md',
      'How can I get access to the Production environment?':
        '/docs/help/access-and-security/how-get-production-access.md',
      'I\'ve removed the "Production" API Product from my APP. How to get it back?':
        '/docs/help/access-and-security/removed-production-api-product.md',
      'What do I need to fill in as grant_type?':
        '/docs/help/access-and-security/grant-type.md',
      'Is the JWT Token generated after authentication digitally signed?':
        '/docs/help/access-and-security/jwt-signed.md',
      'Is the JWT Token generated after authentication encrypted?':
        '/docs/help/access-and-security/jwt-encrypted.md',
      'Is the client ID and Client Secret values encrypted?':
        '/docs/help/access-and-security/client-credentials-encrypted.md',
      'Is Digital Realty following IETF security best practices for JWT?':
        '/docs/help/access-and-security/ietf-jwt-best-practices.md',
    },
  },
  {
    id: 'registration',
    title: 'Registration',
    questions: [
      'How can I get access to the Production environment?',
      'What are API Products?',
      `I've removed the "Production" API Product from my APP, How to get it back?`,
      'How do I report a bug?',
    ],
    navigatePaths: {
      'How can I get access to the Production environment?':
        '/docs/help/registration/production-access.md',
      'What are API Products?':
        '/docs/help/registration/what-are-api-products.md',
      'I\'ve removed the "Production" API Product from my APP, How to get it back?':
        '/docs/help/registration/removed-production-api-product.md',
      'How do I report a bug?': '/docs/help/registration/report-a-bug.md',
    },
  },
  {
    id: 'development',
    title: 'Development',
    questions: [
      'Where to find (error) response codes?',
      'What are the available developer environments?',
      'How do I test my application workflows?',
      'How do I test an API in the sandbox environment?',
      'How can I get access to the Playground environment?',
      'How can I get access to the Sandbox environment?',
      'What are API Products?',
      'Does Digital Realty follow any API design standards?',
    ],
    navigatePaths: {
      'Where to find (error) response codes?':
        '/docs/help/development/response-codes.md',
      'What are the available developer environments?':
        '/docs/help/development/available-environments.md',
      'How do I test my application workflows?':
        '/docs/help/development/test-application-workflows.md',
      'How do I test an API in the sandbox environment?':
        '/docs/help/development/test-api-in-sandbox.md',
      'How can I get access to the Playground environment?':
        '/docs/help/development/playground-access.md',
      'How can I get access to the Sandbox environment?':
        '/docs/help/development/sandbox-access.md',
      'What are API Products?':
        '/docs/help/development/what-are-api-products.md',
      'Does Digital Realty follow any API design standards?':
        '/docs/help/development/api-design-standards.md',
    },
  },
];

export const HELP_TABLE_OF_CONTENTS: DocsTocGroup[] = HELP_SECTIONS.map(
  section => ({
    heading: section.title,
    items: [
      {
        label: section.title,
        route: `/docs-v2/help/${section.id}`,
      },
    ],
  }),
);
